export const FREEZE_WINDOW_DAYS = 8
